module.exports = require('./lib/linkify-html').default;



//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/html.js
// module id = 3R8l
// module chunks = 1